import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Button,
  Paper,
} from '@mui/material';
import { motion } from 'framer-motion';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Link } from 'react-router-dom';

const solutionImages = {
  'aerial-imagery': [
    {
      src: '/images/solutions/images/DSM.png',
      alt: 'LiDAR Scanning',
      caption: 'Digital Surface Model (DSM)'
    },
    {
      src: '/images/solutions/images/A-DEM.png',
      alt: 'Aerial Photography',
      caption: 'Digital Elevation Model (DEM)'
    },
    {
      src: '/images/solutions/images/DEM.png',
      alt: 'Aerial Photography',
      caption: 'Digital Elevation Model (DEM)'
    },
    {
      src: '/images/solutions/images/A-DSM3.png',
      alt: 'Aerial Photography',
      caption: 'Digital Surface Model (DSM)'
    },
    {
      src: '/images/solutions/images/3D.png',
      alt: 'Aerial Photography',
      caption: '3D Modelling'
    },
    {
      src: '/images/solutions/images/Contours.png',
      alt: 'LiDAR Scanning',
      caption: 'Contours'
    },
    {
      src: '/images/solutions/images/design.png',
      alt: 'LiDAR Scanning',
      caption: 'Engineering Designs- Infrastructure Development'
    },
    {
      src: '/images/solutions/images/Image1.jpg',
      alt: 'LiDAR Scanning',
      caption: 'High Resolution Aerial Image 5cm GSD'
    },
    {
      src: '/images/solutions/images/Image2.jpg',
      alt: 'LiDAR Scanning',
      caption: 'High Resolution Aerial Image 5cm GSD'
    },
    {
      src: '/images/solutions/images/Ortho Map1.png',
      alt: 'LiDAR Scanning',
      caption: 'Sample Nairobi Aerial Image 10cm GSD'
    },
    {
      src: '/images/solutions/images/Ortho Map2.png',
      alt: 'Aerial Photography',
      caption: 'Sample Nairobi Aerial Image 10cm GSD'
    },
    {
      src: '/images/solutions/images/Ortho Map3.png',
      alt: 'LiDAR Scanning',
      caption: 'Sample Nairobi Aerial Image 10cm GSD'
    },
    {
      src: '/images/solutions/images/Orthophotomap.jpg',
      alt: 'Aerial Photography',
      caption: 'Sample Nairobi Aerial Image 5cm GSD'
    },
  ],
  'drone-mapping': [
    {
      src: '/images/solutions/images/drone1.png',
      alt: 'Drone Survey',
      caption: 'Mapping Drone'
    },
    {
      src: '/images/solutions/images/drone.png',
      alt: 'Drone Survey',
      caption: 'High Resolution Drone Image 3cm GSD'
    },
  ],
  'satellite-imagery': [
    {
      src: '/images/solutions/images/aerial2.jpeg',
      alt: 'Remote Sensing',
      caption: 'High Resolution Satellite Imagery'
    }
  ],
  'geodetic-survey': [
    {
      src: '/images/solutions/images/A-Geodetic.jpg',
      alt: 'Reference Frame',
      caption: 'RTK Setup'
    },
    {
      src: '/images/solutions/images/B-Geodetic setup1.jpg',
      alt: 'Reference Frame',
      caption: 'RTK Setup'
    },
    {
      src: '/images/solutions/images/B-Geodetic works.png',
      alt: 'Reference Frame',
      caption: 'Geodectic Works'
    },
    {
      src: '/images/solutions/images/geodetic.jpg',
      alt: 'Geodetic Control',
      caption: 'Geodectic Control Network - Nakuru County'
    }
  ],
  'hydrographic-survey': [
    {
      src: '/images/solutions/images/hydro.jpg',
      alt: 'Underwater Mapping',
      caption: 'Underwater terrain mapping and analysis'
    },
  ],
  'geophysical-survey': [
    {
      src: '/images/solutions/images/Geophysical Mapping.png',
      alt: 'Subsurface Analysis',
      caption: 'Geophysical Survey'
    },
    {
      src: '/images/solutions/images/geophysical1.png',
      alt: 'Subsurface Analysis',
      caption: 'Geophysical-Ground Water Exploration'
    },
  ],
  'cadastral-survey': [
    {
      src: '/images/solutions/images/cadastral1.jpg',
      alt: 'Land Boundaries',
      caption: 'Legal land boundary surveys and mapping'
    },
    {
      src: '/images/solutions/images/cadastral3.jpg',
      alt: 'Land Boundaries',
      caption: 'Legal land boundary surveys and mapping'
    },
   
  ],
  'gis-mapping': [
    {
      src: '/images/solutions/images/map4.jpg',
      alt: 'GIS Development',
      caption: 'Topo-Cadastral Mapping'
    },
    {
      src: '/images/solutions/images/soil.png',
      alt: 'GIS Development',
      caption: 'Thematic Mapping'
    },
    {
      src: '/images/solutions/images/map2.jpg',
      alt: 'Spatial Analysis',
      caption: 'Street Mapping'
    }
  ],
  'cartography': [
    {
      src: '/images/solutions/images/planning.jpg',
      alt: 'Map Design',
      caption: 'Urban Spatial Planning'
    },
    {
      src: '/images/solutions/images/planning2.jpg',
      alt: 'Cartographic Services',
      caption: 'Digital Urban Development'
    }
  ],
  'lims': [
    {
      src: '/images/solutions/images/lims.png',
      alt: 'Land Information',
      caption: 'Location of Ratable Property'
    },
    {
      src: '/images/solutions/images/gis_sol.png',
      alt: 'Land Information',
      caption: 'Sample Land Payment Status, Nairobi County'
    },
    {
      src: '/images/solutions/images/geo-solution.png',
      alt: 'Land Information',
      caption: 'The Geomanager Solution'
    },
    {
      src: '/images/geo-dashboard.png',
      alt: 'Land Information',
      caption: 'Geomanager Dashboard'
    },
    {
      src: '/images/geo-modules.jpg',
      alt: 'Land Information',
      caption: 'Geomanager Modules'
    },
    {
      src: '/images/geo-products.jpg',
      alt: 'Property Administration',
      caption: 'Geomanager Products'
    }
  ],
  'software-development': [
    {
      src: '/images/geomanager.png',
      alt: 'Custom Applications',
      caption: 'Custom GIS applications - GeoManager GIS Desktop'
    },
    {
      src: '/images/solutions/images/GeoManager Field2.jpg',
      alt: 'Custom Applications',
      caption: 'Custom GIS applications - GeoManager Field (Mobile)'
    },
  ]
};

const SolutionDetail = ({ solution }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        (prevIndex + 1) % (solutionImages[solution.id]?.length || 1)
      );
    }, 5000); // Change image every 5 seconds

    return () => clearInterval(interval);
  }, [solution.id]);

  return (
    <Box>
      {/* Hero Section */}
      <Box
        sx={{
          position: 'relative',
          minHeight: '50vh',
          maxHeight: '540px',
          display: 'flex',
          alignItems: 'center',
          paddingTop: { xs: '160px', md: '180px' },
          paddingBottom: '60px',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `url("/images/solutions/${solution.id}.png")`,
            backgroundSize: '100% 100%',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            width: '100%',
            height: '100%',
            zIndex: 0,
            objectFit: 'cover',
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            zIndex: 1,
          },
        }}
      >
        <Container sx={{ position: 'relative', zIndex: 2 }}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <Box sx={{ color: 'primary.main', mr: 2 }}>
                {solution.icon}
              </Box>
              <Typography
                variant="h1"
                color="white"
                sx={{
                  fontSize: { xs: '2.5rem', md: '4rem' },
                  fontWeight: 700,
                }}
              >
                {solution.name}
              </Typography>
            </Box>
            <Typography
              variant="h5"
              color="white"
              sx={{
                maxWidth: '800px',
                opacity: 0.9,
              }}
            >
              {solution.description}
            </Typography>
          </motion.div>
        </Container>
      </Box>

      {/* Content Section */}
      <Box sx={{ py: 6, backgroundColor: '#fff' }}>
        <Container maxWidth="lg">
          <Grid container spacing={4}>
            {/* Overview */}
            <Grid item xs={12}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
              >
                <Typography variant="h3" gutterBottom color="primary" sx={{ textAlign: 'justify' }}>
                  Overview
                </Typography>
                <Typography variant="body1" paragraph sx={{ textAlign: 'justify' }}>
                  {solution.overview}
                </Typography>
              </motion.div>
            </Grid>

            {/* Key Features and Image Section */}
            <Grid item xs={12} md={6}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
              >
                <Typography variant="h4" gutterBottom sx={{ textAlign: 'justify' }}>
                  Key Features
                </Typography>
                <List sx={{ py: 0 }}>
                  {solution.features.map((feature, index) => (
                    <ListItem key={index} sx={{ py: 0.1 }}>
                      <ListItemIcon sx={{ minWidth: 36 }}>
                        <CheckCircleIcon color="primary" />
                      </ListItemIcon>
                      <ListItemText 
                        primary={feature.title}
                        secondary={feature.description}
                        primaryTypographyProps={{ 
                          sx: { 
                            textAlign: 'justify',
                            fontWeight: 500,
                            mb: 0.25
                          } 
                        }}
                        secondaryTypographyProps={{ 
                          sx: { 
                            textAlign: 'justify',
                            fontSize: '0.9rem'
                          } 
                        }}
                      />
                    </ListItem>
                  ))}
                </List>
              </motion.div>
            </Grid>

            {/* Image Carousel Section */}
            {solutionImages[solution.id] && (
              <Grid item xs={12} md={6}>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.8, delay: 0.2 }}
                >
                  <Paper
                    elevation={3}
                    sx={{
                      position: 'relative',
                      height: 'auto',
                      overflow: 'hidden',
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      display: 'flex',
                      flexDirection: 'column'
                    }}
                  >
                    <Box
                      sx={{
                        width: '100%',
                        height: '400px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#fff'
                      }}
                    >
                      <Box
                        component="img"
                        src={solutionImages[solution.id][currentImageIndex].src}
                        alt={solutionImages[solution.id][currentImageIndex].alt}
                        sx={{
                          maxWidth: '100%',
                          maxHeight: '100%',
                          width: 'auto',
                          height: 'auto',
                          objectFit: 'contain',
                          transition: 'opacity 0.5s ease-in-out',
                          display: 'block'
                        }}
                      />
                    </Box>
                    <Box
                      sx={{
                        backgroundColor: '#fff',
                        p: 2,
                        borderTop: '1px solid rgba(0, 0, 0, 0.1)',
                        textAlign: 'center'
                      }}
                    >
                      <Typography 
                        variant="h6" 
                        sx={{ 
                          color: '#008080', 
                          fontWeight: 'bold', 
                          fontStyle: 'italic',
                          fontSize: '1.1rem',
                          m: 0
                        }}
                      >
                        {solutionImages[solution.id][currentImageIndex].caption}
                      </Typography>
                    </Box>
                  </Paper>
                </motion.div>
              </Grid>
            )}
          </Grid>
        </Container>
      </Box>

      {/* Benefits Section */}
      <Box sx={{ py: 6, backgroundColor: '#f8f9fa' }}>
        <Container maxWidth="md">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <Card sx={{ p: 3, border: 1, borderColor: 'primary.main', maxWidth: '400px', mx: 'auto' }}>
              <Typography variant="h4" gutterBottom color="primary">
                Benefits
              </Typography>
              <List sx={{ py: 0 }}>
                {solution.benefits.map((benefit, index) => (
                  <ListItem key={index} sx={{ py: 0.25 }}>
                    <ListItemIcon sx={{ minWidth: 36 }}>
                      <CheckCircleIcon color="primary" />
                    </ListItemIcon>
                    <ListItemText 
                      primary={benefit}
                      primaryTypographyProps={{ 
                        sx: { 
                          fontSize: '0.95rem',
                          fontWeight: 500
                        } 
                      }}
                    />
                  </ListItem>
                ))}
              </List>
              <Button
                component={Link}
                to="/contact"
                variant="contained"
                color="primary"
                size="large"
                fullWidth
                sx={{ mt: 3 }}
              >
                Request Service
              </Button>
            </Card>
          </motion.div>
        </Container>
      </Box>
    </Box>
  );
};

export default SolutionDetail; 
